import tripEventsReducer from './tripEventsReducer';

export default tripEventsReducer;
